export enum Route {
  ORIGINE = '/',
  SERVICES = '#services',
  SERVICES_EVENTSTORMING = 'services/eventstorming',
  FORMATIONS_DDD = 'https://academy.3lights-technology.com/formations-catalog/premiers-pas-vers-le-domain-driven-design',
  EXPERTISES = '#expertises',
  A_PROPOS = '#about-us',
  CONTACT = '#contact',
  BLOG = 'blog',
  ACADEMY = 'https://academy.3lights-technology.com',
}
